"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var styles_utils_1 = require("../styles/utils/styles_utils");
var styles_1 = require("@material-ui/core/styles");
var center = styles_utils_1.flexUtils.center;
exports.styles = styles_1.createStyles({
    container: __assign({ height: 'fit-content', width: 'fit-content', whiteSpace: 'nowrap', borderRadius: 100, margin: '10px 7.5px', padding: '12px 12px', color: '#fff', backgroundColor: 'currentColor' }, center),
    typography: {
        display: 'flex',
        alignItems: 'center',
    },
});
